import api from '../../services/api';

interface ReceiptRequest { client_ref: string; line_id: number; qty: number; location: 'office' | 'store' }
const active = new Set<number>();

/** Persist the exact attempt before sending; repeated partial receipts each receive a fresh identity. */
export async function submitCounterReceipt(lineId: number, qty: number, location: 'office' | 'store') {
  if (active.has(lineId)) throw new Error('這筆正在收貨，請稍候。');
  const key = `noke-receipt-pending-${lineId}`;
  const saved = sessionStorage.getItem(key);
  const request: ReceiptRequest = saved ? JSON.parse(saved) : {
    client_ref: `recv-${lineId}-${Date.now()}-${Math.random().toString(36).slice(2)}`,
    line_id: lineId, qty, location,
  };
  sessionStorage.setItem(key, JSON.stringify(request));
  active.add(lineId);
  try {
    const result = await api.post('/api/receiving/counter-orders/receive', request);
    sessionStorage.removeItem(key);
    return { ...result.data, requested_location: request.location };
  } catch (error: any) {
    if (error?.response?.status >= 400 && error.response.status < 500 && ![408, 429].includes(error.response.status)) sessionStorage.removeItem(key);
    throw error;
  } finally { active.delete(lineId); }
}

const isRefusal = (error: any) =>
  error?.response?.status >= 400 && error.response.status < 500 && ![408, 429].includes(error.response.status);

/**
 * 移除 one 門市 line = cancel its still-awaited remainder through the same order-task verb the
 * 訂貨 workflow uses. Received pieces are untouched. Same persisted-identity rule as a receipt:
 * a timeout retries the original request instead of minting a second cancel.
 */
export async function submitCounterCancelLine(lineId: number, qty: number) {
  const key = `noke-cancel-pending-${lineId}`;
  const saved = sessionStorage.getItem(key);
  const request = saved ? JSON.parse(saved) : {
    client_ref: `cancel-${lineId}-${Date.now()}-${Math.random().toString(36).slice(2)}`,
    line_id: lineId, action: 'cancel_remainder', qty,
  };
  sessionStorage.setItem(key, JSON.stringify(request));
  try {
    const result = await api.post('/api/noke/restock-v2/order-task', request);
    sessionStorage.removeItem(key);
    return result.data;
  } catch (error: any) {
    if (isRefusal(error)) sessionStorage.removeItem(key);
    throw error;
  }
}

/** Whole-parcel cancel. The backend refuses once any line has stock received (409). */
export async function submitCounterCancelOrder(batchId: number) {
  const result = await api.post('/api/noke/restock-v2/counter-order/cancel', { id: batchId });
  return result.data;
}
